const rollerInfo = {
    0: 0,
    1: 225,
    2: 55,
    3: 345,
    4: 35,
    5: 185,
    6: 95,
    7: 305,
    8: 155,
    9: 265,
    10: 175,
    11: 135,
    12: 325,
    13: 115,
    14: 245,
    15: 15,
    16: 205,
    17: 75,
    18: 285,
    19: 25,
    20: 235,
    21: 45,
    22: 275,
    23: 165,
    24: 195,
    25: 65,
    26: 355,
    27: 105,
    28: 315,
    29: 295,
    30: 145,
    31: 255,
    32: 5,
    33: 215,
    34: 85,
    35: 335,
    36: 125,
};

const rolletDocSelectors = {
    ball: "#ball",
    ballSpin: "#ballSpin"
};

const getCustomColor = (num) => {
    num = Number(num);
    const red = [1, 7, 13, 22, 28, 34];
    const green = [2, 8, 14, 23, 29, 35];
    const pink = [3, 9, 15, 24, 30, 36];
    const yellow = [4, 10, 16, 19, 25, 31];
    const purple = [5, 11, 17, 20, 26, 32];
    const blue = [6, 12, 18, 21, 27, 33];

    if (red.includes(num)) return 'red';
    if (green.includes(num)) return 'green';
    if (pink.includes(num)) return 'pink';
    if (yellow.includes(num)) return 'yellow';
    if (purple.includes(num)) return 'purple';
    if (blue.includes(num)) return 'blue';
    return '';
};

const checkOddEven = (num) => {
    num = Number(num);
    if (num % 2 === 0) return 'គ'
    else return 'ស'
};

const getUnderOver = (number) => {
    number = Number(number)
    if (number >= 1 && number <= 18) {
        return "under"
    } else if (number >= 19 && number <= 36) {
        return "over"
    } else {
        return ""
    }
}

const getRangeColor = {
    RED: "1, 7, 13, 22, 28, 34",
    GREEN: "2, 8, 14, 23, 29, 35",
    PINK: "3, 9, 15, 24, 30, 36",
    YELLOW: "4, 10, 16, 19, 25, 31",
    PURPLE: "5, 11, 17, 20, 26, 32",
    BLUE: "6, 12, 18, 21, 27, 33"
}

const prepareBetNum = (arr) => {
    const result = [];
    const half = arr.length / 2;
    const chunk = 6;

    for (let i = 0; i < half; i += chunk) {
        const block1 = arr.slice(i, i + chunk);
        const block2 = arr.slice(half + i, half + i + chunk);
        result.push(...block1, ...block2);
    }

    return result;
}

export {
    rollerInfo,
    rolletDocSelectors,
    getUnderOver,
    checkOddEven,
    getCustomColor,
    getRangeColor,
    prepareBetNum
}



